import type { RouterState } from "@/types/store";
import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import {
  type RouterViewMode,
  RouterViewModeType,
  type ElementState,
  type UnitState,
} from "@/types";

const elementSate: ElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

const viewMode: RouterViewMode = {
  type: RouterViewModeType.NONE,
  currentEntityId: "",
  source: "",
};

const unitsState: UnitState = {
  data: [],
  error: null,
  loading: false,
};

export const routerState: RouterState = {
  viewMode,
  clients: elementSate,
  places: elementSate,
  projects: elementSate,
  clientsPlaces: elementSate,
  aggregations: elementSate,
  units: unitsState,
};

export const RouterModule = {
  namespaced: true,
  state: routerState,
  getters,
  actions,
  mutations,
};
